<template>
  <div class="union-content">
    <div class="city-select">
      <span class="city-select__title">Правильное название</span>
      <!--multiselect
        v-model="cityValue"
        :options="cityList"
        :placeholder="$t('feed.audit.unionCity.body.city.multiselect.placeholder')"
        :max-height="150"
        :deselectLabel="$t('feed.audit.unionCity.body.city.multiselect.deselectLabel')"
        :selectLabel="$t('feed.audit.unionCity.body.city.multiselect.selectLabel')"
        :selectedLabel="$t('feed.audit.unionCity.body.city.multiselect.selectedLabel')"
      /-->
      <el-input size="small" v-model="cityValue"></el-input>
    </div>
    <div class="city-select">
      <span class="city-select__title">Неправильное название</span>
      <multiselect
        v-model="citySynonym"
        :options="cityList"
        :placeholder="$t('feed.audit.unionCity.body.synonym.multiselect.placeholder')"
        :max-height="150"
        :deselectLabel="$t('feed.audit.unionCity.body.synonym.multiselect.deselectLabel')"
        :selectLabel="$t('feed.audit.unionCity.body.synonym.multiselect.selectLabel')"
        :selectedLabel="$t('feed.audit.unionCity.body.synonym.multiselect.selectedLabel')"
      />
    </div>
    <div class="city-select__button">
      <el-button type="primary" @click="toUnion">{{$t('feed.audit.unionCity.body.apply')}}</el-button>
    </div>
  </div>
</template>

<script>
  // components
  import Multiselect from 'vue-multiselect'

  export default {
    name: "UnionBody",
    props: {
      cityList: {
        type: Array
      },
      activeCity: {
        type: String
      },
      synonym: {
        type: String
      },
    },
    data() {
      return {

      }
    },
    methods: {
      toUnion() {
        this.$emit('toUnion', {city: this.cityValue, synonym: this.citySynonym}).then(() => {
          this.$notify({
            title: 'Обновлено',
            message: 'Города объеденены',
            type: 'success',
            duration: 1500,
            showClose: false
          });
        })
      },
    },
    computed: {
      cityValue: {
        get() {
          return this.activeCity;
        },
        set(value) {
          this.$emit('setCity', value);
        }
      },
      citySynonym: {
        get() {
          return this.synonym;
        },
        set(value) {
          this.$emit('setSynonym', value);
        }
      }
    },
    mixins: [

    ],
    components: {
      Multiselect
    }
  };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  @import "../../../../../../../../style/tonal.css";

  .city-select {
    margin-bottom: 15px;
  }
  .city-select__title {
    display: block;
    margin-bottom: 5px;
    font-family: "Roboto", "Arial", sans-serif;
    font-size: 16px;
    line-height: normal;
  }
  .city-select__button {
    display: flex;
    justify-content: flex-end;
  }
</style>
